import { featureCollection, point } from '@turf/helpers'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import set from 'lodash/set'
import unset from 'lodash/unset'

import PoziAPIData from 'api/data'

// A (Adapter)-> is implemented in order to follow the standard Adapter pattern
function GetAddressFromHereMaps () {
  // Adapters
  const adapters = {
    /**
     * @api {NA} PoziHereAddress().getGeoJSON Get Here address data as GeoJSON
     * @apiDescription Pass Here address URL to get data as GeoJSON
     * @apiGroup HereAddress
     * @apiName getGeoJSON
     *
     * @apiParam {String} URL Here address url
     *
     * @apiSuccess {Promise} Resolve No errors
     * @apiError {Promise} Reject Error
     */
    getGeoJSON: function (url) {
      return getGeoJSON(url)
    },
    getGeoJSONFromLngLat: function (lng, lat) {
      return getGeoJSONFromLngLat(lng, lat)
    }
  }

  var getGeoJSONFromLngLat = function (lng, lat) {
    const url = 'https://reverse.geocoder.cit.api.here.com/6.2/reversegeocode.json?prox=' + lat + ',' + lng + ',100&mode=retrieveAddresses&gen=8&app_id=pYZXmzEqjmR2DG66DRIr&app_code=T-Z-VT6e6I7IXGuqBfF_vQ'
    return getGeoJSON(url)
  }

  /**
   * Handle data requests
   */
  var getGeoJSON = function (url) {
    return new Promise(function (resolve, reject) {
      let err = ''
      if (isNil(url)) {
        err = 'Invalid url.'
        return reject(err)
      }

      console.log('PoziHereAddress url', url)

      PoziAPIData().ajax({
        url,
        error: function (err) {
          console.log('PoziHereAddress ajax error: ', err)
          reject(err)
        },
        success: function (hereMapsData) {
          convertToGeoJSON(hereMapsData)
            .then(function (geojson) {
              resolve(geojson)
            })
            .catch(function (err) {
              console.log('PoziHereAddress parse error: ', err)
              reject(err)
            })
        }
      })
    })
  }

  /**
   * Handle data requests
   * @param jotFormData (string directly from jotFormData API)
   * @return FeatureCollection
   */
  var convertToGeoJSON = function (hereMapsData) {
    return new Promise(function (resolve, reject) {
      let err = ''

      const features = []
      const fc = featureCollection(features)

      if (isNil(hereMapsData)) {
        err = 'Invalid hereMapsData object.'
        return reject(err)
      }
      const results = get(hereMapsData, 'Response.View.0.Result', [])
      if (results.length === 0) {
        console.log('No features found.')
        return resolve(fc)
      }

      // Here maps returns a bunch of results ordered by Relevant and Distance. Just take the top one.
      // for (var key in results) {
      const result = results[0]

      const properties = get(result, 'Location.Address', {})
      unset(properties, 'AdditionalData')
      set(properties, 'marker-symbol', 'default')

      const lngValue = get(result, 'Location.DisplayPosition.Longitude', 0)
      const latValue = get(result, 'Location.DisplayPosition.Latitude', 0)

      const pt = point([lngValue * 1, latValue * 1], properties)
      features.push(pt)
      // }

      return resolve(fc)
    })
  }

  return adapters // Return adapters (must be at end of adapter)
}
export default GetAddressFromHereMaps
// End A (Adapter)
